export default "__VITE_ASSET__VNT_0n2d__"